import { styles } from './PercentOffText.css';
import React from 'react';

import PriceFont from '@jbhi-fi/lanyard-ui/font/PriceFont';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type PercentOffTextProps = {
  percentOff: number;
  color: React.CSSProperties['color'];
  className?: string;
};

export const PercentOffText = ({ percentOff, color, className }: PercentOffTextProps) => {
  return (
    <PriceFont className={classNames(styles.percentOffText, className)} style={{ color }} as="span">
      {percentOff}
      <CalloutFont as="span" className={styles.percentSignBlock}>
        %<span className={styles.offText}>OFF^</span>
      </CalloutFont>
    </PriceFont>
  );
};
